/* tslint:disable */

declare var Object: any;
export interface ProxyInterface {
  "id"?: any;
}

export class Proxy implements ProxyInterface {
  "id": any;
  constructor(data?: ProxyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Proxy`.
   */
  public static getModelName() {
    return "Proxy";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Proxy for dynamic purposes.
  **/
  public static factory(data: ProxyInterface): Proxy{
    return new Proxy(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Proxy',
      plural: 'Proxies',
      path: 'Proxies',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
